export const API_URL = process.env.REACT_APP_API_URL

export const schedule_URL = API_URL + '/drive/through/test/add?labId=' + process.env.REACT_APP_LAB_ID
export const eligible_URL =API_URL +'/drive/through/check/eligible/appointment?labId=' + process.env.REACT_APP_LAB_ID